import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TrashIcon from '@mui/icons-material/Delete';
import { Button, CircularProgress, Grid, IconButton, Tooltip } from '@mui/material';
import Modal from '../util/modal.js';
import Form from './form.js';

import { createSingleArancel, delSingleArancel, updateSingleArancel } from '../../redux/actions/arancelActions.js';
import useMonedas from '../../swr/hooks/useMonedas.js';
import { useHandleChange, useHandleChangeNumber } from '../hooks/useChange.js';

const defaultState = {
  description: '',
  cost: '0',
  code: '',
  id: 0,
  title: false
}

const ModalArancel = ({ item, open, moneda, arancel, onChangeMoneda, onClose }) => {
  const dispatch = useDispatch();
  const { data: monedas } = useMonedas();
  const loading = useSelector(state => state.arancel.loading)
  const [state, setState] = useState(defaultState)
  const [error, setError] = useState({})

  useEffect(function () {
    if (open && item) {
      setState({
        code: item.Codigo,
        cost: item.Precio || 0,
        description: item.Tratamiento,
        id: item.idTratamiento,
        title: item.EsTitulo
      })
      onChangeMoneda(item.id_moneda)
    }
    //eslint-disable-next-line
  }, [open, item])

  const handleClose = () => {
    onClose();
    setState(defaultState)
  }

  const handleSubmit = e => {
    e.preventDefault();

    const error = {}
    if (!state.description.trim().length) {
      error.description = 'La descripcion no puede estar vacia.';
    }
    if (state.description.trim().length >= 150) {
      error.description = 'La descripción excede el largo máximo permitido. (150 caracteres).';
    }
    if (isNaN(+state.cost)) {
      error.cost = 'El precio no es valido.';
    }

    const namecode = +state.code.replace(new RegExp('.', 'g'), '');
    if (state.code.trim().length < 1 || namecode < 0 || isNaN(namecode)) {
      error.code = 'El formato valido es: `1X.XX` ';
    }
    if (state.code.trim().length > 10) {
      error.code = 'El formato es muy largo';
    }

    if (!Object.keys(error).length) {
      if (state.id) {
        dispatch(updateSingleArancel(state.id, { ...state, coin: moneda, cost: +state.cost > 0 ? state.cost : 0 }, handleClose))
      } else {
        dispatch(createSingleArancel(arancel.idArancel, { ...state, coin: moneda, cost: +state.cost > 0 ? state.cost : 0 }, handleClose))
      }
    }

    setError(error);
  }


  const handleChange = useHandleChange(setState)
  const handleNumber = useHandleChangeNumber(setState)
  const handleCheck = () => setState({ ...state, title: !state.title })
  const handleMoneda = ({ target }) => onChangeMoneda(target.value)

  const handleDelete = () => dispatch(delSingleArancel(state.id, handleClose))

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      buttons={(
        <Grid container justifyContent="space-between">
          {
            state.id ? (
              <Grid item xs={2}>
                <Tooltip title="Eliminar Item" aria-label="Eliminar Item" placement="right" arrow>
                  <IconButton onClick={handleDelete}>
                    <TrashIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : null
          }
          <Grid item container xs justifyContent="flex-end" gap={3}>
            <Button
              color="secondary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <div className="relative">
              <Button
                color="primary"
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
              >
                {state.id ? 'Actualizar' : 'Guardar'}
              </Button>
              {
                loading &&
                <CircularProgress
                  size={24}
                  className={"re-loading"}
                />
              }
            </div>
          </Grid>
        </Grid>
      )}
    >
      <Form
        state={state}
        error={error}
        moneda={moneda}
        monedas={monedas}
        handleMoneda={handleMoneda}
        handleChange={handleChange}
        handleNumber={handleNumber}
        handleCheck={handleCheck}
        handleSubmit={handleSubmit}
      />
    </Modal>
  )
}

export default ModalArancel;
